/**
 * Extraction Configuration Constants
 * Centralized configuration for roster extraction operations
 */

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const EXTRACTION_TIMEOUT_MS = 180000; // 3 minutes
export const SEARCH_DEBOUNCE_MS = 400;
export const DEFAULT_PAGE_SIZE = 15;
export const MAX_PAGINATION_BUTTONS = 5;

/**
 * Page sizes offered by the players list.
 *
 * 100 is the ceiling because the API clamps `pageSize` there (see the paged
 * prospects endpoint in ProspectsController) — offering more would silently
 * return the API's own default instead.
 */
export const PAGE_SIZE_OPTIONS = [15, 25, 50, 100] as const;
